import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Icon } from '@ss/mtd-react3';
import classNames from 'classnames';
import { lx } from '@cap/rzmt-core';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { selectModuleMap, changeIcon, selectCurIcon, getModuleContent } from '@/pages/home/homeCourseData';
import { EnumModuleCode } from '@/utils/const';
import { getModuleIdList } from '@/utils/func';

import './index.less';

const IconList: React.FC = () => {
  const dispatch = useAppDispatch();
  const moduleMap = useAppSelector(selectModuleMap);
  const [expandStatus, setExpandStatus] = useState<boolean>(false);
  const curIcon = useAppSelector(selectCurIcon);
  const [highlight, setHighlight] = useState<number>(curIcon.id);
  const [containerHeight, setContainerHeight] = useState<number>(56); // 用状态存储高度
  const outerDivRef = useRef<HTMLDivElement>(null); // 创建 ref

  const expand = () => {
    setExpandStatus((prevCount) => !prevCount);
  };

  const displayList = useMemo(() => {
    const moduleData = moduleMap[EnumModuleCode.Icon];
    if (!moduleData?.length) return [];
    return moduleData[0].iconList;
  }, [moduleMap]);

  const selected = async (item) => {
    lx.moduleClick({
      bid: 'b_donation_thrsl2uz_mc',
      custom: {
        professionId: item.id,
      },
    });
    const { id } = item;
    setHighlight(id);
    if (id === curIcon?.id) return;
    dispatch(changeIcon(item));
    const moduleIdList = getModuleIdList(moduleMap);
    const { dataRule } = item;
    localStorage.setItem('dataRule', dataRule);
    await dispatch(getModuleContent({ pageNo: 1, moduleIdList, dataRule }));
  };

  useEffect(() => {
    const length = displayList?.length || 7;
    const num = Math.ceil(length / 7);
    if (!expandStatus) {
      setContainerHeight(56); // 设置初始高度
    } else {
      const additionalHeight = (num - 1) * 72; // 计算额外增加的高度
      const totalHeight = 56 + additionalHeight; // 初始高度 + 增加的高度
      setContainerHeight(totalHeight); // 更新状态来设置最终的高度
    }
    setHighlight(curIcon.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandStatus, displayList]); // 每次 expandStatus 改变时，重新获取高度

  return (
    <div className="icon-list">
      <div className="top-title">
        <div className="title">行业品类</div>
        <div className="icon" onClick={expand}>
          {displayList && displayList.length > 7 && (
            <div>
              {expandStatus ? '收起' : '展开'}
              <Icon type={expandStatus ? 'up' : 'down'} className="down" />
            </div>
          )}
        </div>
      </div>

      <div
        ref={outerDivRef}
        className={expandStatus ? 'content-contract' : 'content-expand'}
        style={{ height: `${containerHeight}px` }} // 通过样式应用计算后的高度
      >
        {displayList &&
          displayList.map((item) => (
            <div
              className={classNames('item', { borderfdo: item.id === highlight })}
              key={item.id}
              onClick={() => selected(item)}
            >
              <div className={classNames('item-icon', { selected: item.id === highlight })}>
                <img src={item.iconUrl} alt="" />
                <span className={classNames('item-icon-span ', { selectedspan: item.id === highlight })}>
                  {item.name}
                </span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default IconList;
